import { render } from "./SubscriptionModalForm.vue?vue&type=template&id=5e8ddc74"
import script from "./SubscriptionModalForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionModalForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Host\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__